export default __webpack_public_path__ + "static/media/Topaz_partment_1.aac71aad.jpg";